import { t } from 'i18next';

export enum OperationType {
  ASYMMETRIC_KEY_GENERATION = 'ASYMMETRIC_KEY_GENERATION',
  WRAPPING = 'WRAPPING',
  UNWRAPPING = 'UNWRAPPING',
  ENCRYPTION = 'ENCRYPTION',
  DECRYPTION = 'DECRYPTION',
  DIGEST = 'DIGEST',
  KEY_AGREEMENT = 'KEY_AGREEMENT',
  KEY_DEFINITION = 'KEY_DEFINITION',
  KEYSTORE_LOAD = 'KEYSTORE_LOAD',
  KEYSTORE_STORE = 'KEYSTORE_STORE',
  MAC = 'MAC',
  PASSWORD_BASED_DERIVATION = 'PASSWORD_BASED_DERIVATION',
  SIGNATURE = 'SIGNATURE',
  SIGNATURE_VERIFICATION = 'SIGNATURE_VERIFICATION',
  SYMMETRIC_KEY_GENERATION = 'SYMMETRIC_KEY_GENERATION',
  TLS_HANDSHAKE = 'TLS_HANDSHAKE',
  TLS_INITIALIZATION = 'TLS_INITIALIZATION',
  SSH_HANDSHAKE = 'SSH_HANDSHAKE',
}

export const getOperationTypeLabel = (type: OperationType): string => {
  return t(`operationProperties.types.${type}`);
};
